export default __webpack_public_path__ + "static/media/Background_00206.32ed8641.png";